import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link, useParams} from 'react-router-dom';

import api from '../api';

export default ({children}) => {
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const [panic, setPanic] = useState(null);
  const {subject_number} = useParams();

  useEffect(() => {
    api.get('/attend/'+subject_number)
      .then((res) => {
        if ( res.data.status == 4 ) {
          return;
        }
        setLoaded(true);
      }).catch(error => {
        if ( error.code == 404 ) {
          setLoaded(true);
        } else {
          setPanic(true);
        }
      });
  }, []);

  useEffect(() => {
    if ( loaded ) {
      if (!sessionStorage.getItem('SIGN')) {
        history.push('/attend/'+subject_number+'/confirm');
      }
    }
  }, [loaded]);

  if ( panic ) throw panic;
  return children;
};
